import React from "react";

const DotIcon = ({ className, fill = "#16A34A" }) => {
  return (
    <svg
      width="5"
      height="6"
      viewBox="0 0 5 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className} // Apply className prop
    >
      <path
        d="M4.8513 3.08971C4.8513 3.67761 4.61776 4.24143 4.20206 4.65713C3.78635 5.07284 3.22253 5.30638 2.63464 5.30638C2.04674 5.30638 1.48292 5.07284 1.06722 4.65713C0.65151 4.24143 0.417969 3.67761 0.417969 3.08971C0.417969 2.50182 0.65151 1.938 1.06722 1.52229C1.48292 1.10659 2.04674 0.873047 2.63464 0.873047C3.22253 0.873047 3.78635 1.10659 4.20206 1.52229C4.61776 1.938 4.8513 2.50182 4.8513 3.08971Z"
        fill={fill} // Apply fill prop
      />
    </svg>
  );
};

export default DotIcon;
